 export function positionCircle(numIcons) {
    var circle = document.getElementById('disc'),
        imgs = document.getElementsByClassName('icon');
  
    // get circle diameter
    // getBoundingClientRect outputs the actual px AFTER transform
    // using getComputedStyle does the job as we want
    var diam = parseInt( window.getComputedStyle(circle).getPropertyValue('width') ),
        radius = diam/2,
        imgW = imgs[0].getBoundingClientRect().width,
    // get the dimensions of the inner circle we want the images to align to
        radius2 = radius - imgW;
  
    var i,
        alpha = Math.PI / 2,
        corner = 2 * Math.PI / numIcons;
  
    // loop over the images and assign the correct css props
    let coords = Array(numIcons);
    for ( i = 0 ; i < numIcons; i++ ){
        var leftPos = parseInt( ( radius - imgW / 2 ) + ( radius2 * Math.cos( alpha ) ) );
        var topPos = parseInt( ( radius - imgW / 2 ) - ( radius2 * Math.sin( alpha ) ) );
        // var discHeight = document.getElementById('disc').getAttribute('height');
        coords[i] = [leftPos, topPos];
        imgs[i].style.left = leftPos + 'px';
        imgs[i].style.top =  topPos + 'px';
  
      alpha = alpha - corner;
    }
    return coords;
}

export function swappableIndices(numIcons) {
    let swappable = Array(numIcons);
    for (let idx=0; idx < numIcons; idx++) {
        let canSwap = Array(2);

        if ((idx+1) > (Math.floor(numIcons/2))) {
          canSwap[0] = (idx+1) - (Math.floor(numIcons/2));
        } else {
          canSwap[0] = (idx+1) + (Math.floor(numIcons/2));
        }
      
        if ((idx-1) > (Math.floor(numIcons/2))) {
          canSwap[1] = (idx-1) - (Math.floor(numIcons/2));
        } else {
          canSwap[1] = (idx-1) + (Math.floor(numIcons/2));
        }
      
        // correct for zero index
        if (idx === (numIcons/2 - 1)) {
          canSwap[0] = 0;
        } else if (idx === (numIcons/2 + 1)) {
          canSwap[1] = 0;
        }
        swappable[idx] = canSwap;
    }
    return swappable;
}

export function showIcons(iconOrder, numIcons) {  
    let i = 0;
    let icons = document.getElementsByClassName('icon');
    for (let j = 0; j < numIcons; j++) {
        icons[j].style.opacity = '0';
        icons[j].style.transitionDuration = '250ms';
        icons[j].style.pointerEvents = 'none';
    }
    
    let id = setInterval(() => {
        if (i === numIcons) {  
            clearInterval(id);
        } else {
            document.querySelector(`input[src='${iconOrder[i]}']`).style.opacity = '1';
            document.querySelector(`input[src='${iconOrder[i]}']`).style.pointerEvents = 'unset';
            i++; 
        }
    }, 100);

}